import React from "react";
import { Button, Popover } from "antd";
import { DotsMenuIcon } from "../icons/dots-menu-icon";
import { TooltipPlacement } from "antd/es/tooltip";
import { BemHelper } from "../utils";
import classNames from "classnames";

type Props = {
  content: React.ReactNode;
  placement?: TooltipPlacement;
  hideButton?: boolean;
}

const bem = new BemHelper("floating-menu");

export const FloatingMenu: React.FC<Props> = ({ content, placement = "left", hideButton = false }) => {
  const getContainer = (el: HTMLElement) => el

  const container = (
    <div className={classNames(bem.element('container'))}>
      {content}
    </div>
  )

  if (hideButton) {
    return container
  }

  return (
    <Popover
      className={classNames(bem.block())}
      content={container}
      trigger="click"
      placement={placement}
      getPopupContainer={getContainer}
    >
      <Button type="text" icon={<DotsMenuIcon />} />
    </Popover>
  )
}